module.exports = __webpack_public_path__ + "static/media/4_HOTEL INDIGO HAKONE GORA - Japan.8adeadb2.jpg";